import { Text } from '@leroy-merlin-br/backyard-react'
import { Fragment } from 'react'

import { RatingStars } from 'shared/components/RatingStars'

import * as S from './styled'

type Props = {
  isAssistedSale: boolean
  productId: number
  url: string
  badges: {
    cod: number
    tag?: {
      type: string
      label: string
    }
    ean?: string
    avs?: boolean
    expiredAvs?: boolean
    vef?: boolean
    bndes?: boolean
  }
}

type AssistedSaleBadges = {
  ean?: string
  avs?: boolean
  expiredAvs?: boolean
  vef?: boolean
  bndes?: boolean
}

const Badges = ({ productId, url, badges, isAssistedSale }: Props) => {
  const { ean, cod, avs, expiredAvs, vef, bndes, tag } = badges
  const renderAssistedSaleBadges = ({
    ean,
    avs,
    expiredAvs,
    vef,
    bndes
  }: AssistedSaleBadges) => {
    return (
      <Fragment>
        {Boolean(ean) && (
          <S.Badge type={'productCode'}>
            <Text size="kilo" color="n900" isBold noMargin>
              Ean. {ean}
            </Text>
          </S.Badge>
        )}

        {(avs || expiredAvs) && (
          <S.Badge type={expiredAvs ? 'expiredAvs' : 'assistedSale'}>
            <Text size="kilo" color="white" isBold noMargin>
              AVS
            </Text>
          </S.Badge>
        )}

        {vef && (
          <S.Badge type={'assistedSale'}>
            <Text size="kilo" color="white" isBold noMargin>
              VEF
            </Text>
          </S.Badge>
        )}

        {bndes && (
          <S.Badge type={'bndes'}>
            <Text size="kilo" color="white" isBold noMargin>
              BNDES
            </Text>
          </S.Badge>
        )}
      </Fragment>
    )
  }

  return (
    <S.Wrapper>
      <S.RatingStarsWrapper>
        <RatingStars id={productId} url={url} />
      </S.RatingStarsWrapper>

      <S.Badge type={'productCode'}>
        <Text size="kilo" color="n900" isBold noMargin>
          Cód. {cod}
        </Text>
      </S.Badge>

      {tag && (
        <S.Badge type={tag.type}>
          <Text size="kilo" color="white" isBold noMargin>
            {tag.label}
          </Text>
        </S.Badge>
      )}

      {isAssistedSale &&
        renderAssistedSaleBadges({ ean, avs, expiredAvs, vef, bndes })}
    </S.Wrapper>
  )
}

export default Badges
